import ReportMessage from "./ReportMessage";
import ImageChangeInfo from "./ImageChangeInfo";
import { useStore } from 'react-redux';
import G from './Getters';



export default function SupplementReportImageEnhancements({value,replicate,target}){

  let focus = replicate;
  //let report = useReport();

  //let enh = report;

  const store = useStore();
  const state = store.getState();



  

  return (
    <div>
    <div>
    </div>
    <ReportMessage {...{
      type:"alert",
    }}>
    <b>Image quality too low.</b>
    </ReportMessage>
      <ImageChangeInfo {...{
        label:replicate.label,
        selectedImageId:G.getImageSetFigureImageIdByAnnotationId(state,{annotationId:replicate.annotationId}),
        silenceUnadjusted:true,
      }}/>
    </div>
    
  )


}
